var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('menu-drop', {
    scopedSlots: _vm._u([{
      key: "description",
      fn: function () {
        return [_c('h2', {
          staticClass: "gh-discoverContentHeader"
        }, [_vm._v("Discover our full range of content")]), _c('p', [_vm._v(" Our innovative products and services for learners, authors and customers are based on world-class research and are relevant, exciting and inspiring. ")])];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('discovery-tool-integration', {
          attrs: {
            "environment": _vm.environment
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };